import React, { useState } from 'react';
import { CreateFlowModal } from './CreateFlowModal';
import { ModalContent } from './shared/FormComponents';
import { CreateFlowStepIndicator } from './shared/CreateFlowStepIndicator';
import { CreateFlowBackButton } from './shared/CreateFlowBackButton';
import { CreateTypeSelector } from './shared/CreateTypeSelector';
import { ManualCreateContentModal } from './ManualCreateContentModal';
import { SmartCreateContentModal } from './SmartCreateContentModal';
import { GoalType } from 'models/set';
import { getContentTypeDisplayName } from './shared/contentTypeUtils';

interface IProps {
  goalType: GoalType;
  onClose: () => void;
  onBack: () => void;
  onSetCreated?: () => void;
}

type ContentCreationStep = 'method-selection' | 'manual-create' | 'smart-create';

export const CreateContentMethodModal = (props: IProps) => {
  const { goalType, onClose, onBack, onSetCreated } = props;
  const startingStep = goalType === 'survey' ? 'manual-create' : 'method-selection';
  const [currentStep, setCurrentStep] = useState<ContentCreationStep>(startingStep);

  const handleManualCreateClick = () => {
    setCurrentStep('manual-create');
  };

  const handleSmartCreateClick = () => {
    setCurrentStep('smart-create');
  };

  const handleBackToMethodSelection = () => {
    // For surveys, go back to the original caller instead of method selection
    if (goalType === 'survey') {
      onBack();
    } else {
      setCurrentStep('method-selection');
    }
  };

  if (currentStep === 'manual-create') {
    return <ManualCreateContentModal goalType={goalType} onClose={onClose} onBack={handleBackToMethodSelection} onSetCreated={onSetCreated} />;
  }

  if (currentStep === 'smart-create') {
    return <SmartCreateContentModal goalType={goalType} onClose={onClose} onBack={handleBackToMethodSelection} onSetCreated={onSetCreated} />;
  }

  const contentTypeDisplayName = getContentTypeDisplayName(goalType);

  return (
    <CreateFlowModal title={`Create ${contentTypeDisplayName}`} onClose={onClose}>
      <ModalContent>
        <CreateFlowBackButton onClick={onBack} />

        <CreateFlowStepIndicator activeStep={2} />

        <CreateTypeSelector onManualCreateClick={handleManualCreateClick} onSmartCreateClick={handleSmartCreateClick} />
      </ModalContent>
    </CreateFlowModal>
  );
};
